import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import {Modal, Table, Loader, Button} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {shortDate} from '../../../common/constants/datesFormat';

class PortArrivalAudit extends Component {
  componentDidUpdate(prevProps) {
    const {invoice, isOpen} = this.props;

    if (isOpen && invoice && invoice !== prevProps.invoice) {
      this.props.getPortArrivalAuditLog(invoice.code);
    }
  }

  renderBody() {
    const {loading, log} = this.props;

    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%' textAlign='center'>
            <Loader active inline='centered'>Consultando...</Loader>
          </Table.Cell>
        </Table.Row>
      );
    }

    if (!log.length) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%' textAlign='center'>
            No se encontraron elementos.
          </Table.Cell>
        </Table.Row>
      );
    }

    return log.map((register, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center'>{register.user.toUpperCase()}</Table.Cell>
          <Table.Cell textAlign='center'>{moment(register.date).format(shortDate)}</Table.Cell>
          <Table.Cell textAlign='center'>
            {register.previousValue ? moment(register.previousValue).format(shortDate) : ''}
          </Table.Cell>
          <Table.Cell textAlign='center'>{moment(register.updatedValue).format(shortDate)}</Table.Cell>
        </Table.Row>
      );
    });
  }

  render() {
    const {invoice, isOpen, closeHandler} = this.props;
    const {code} = invoice || {};

    return (
      <Modal
        closeOnDimmerClick={false}
        open={isOpen}
        onClose={closeHandler}
        trigger={<span />}
      >
        <Modal.Header>Auditoría ETA Puerto - {code}</Modal.Header>
        <Modal.Content>
          <div>
            <Table>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell textAlign='center'>Usuario</Table.HeaderCell>
                  <Table.HeaderCell textAlign='center'>Fecha de cambio</Table.HeaderCell>
                  <Table.HeaderCell textAlign='center'>Valor previo</Table.HeaderCell>
                  <Table.HeaderCell textAlign='center'>Valor actualizado</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {this.renderBody()}
              </Table.Body>
            </Table>
          </div>
        </Modal.Content>
        <Modal.Actions>
          <Button primary content='ACEPTAR' onClick={closeHandler} />
        </Modal.Actions>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.providersImportations.loadingLog,
    'log': state.providersImportations.auditLog,
    'invoice': state.providersImportations.selectedInvoice,
  };
};

const {getPortArrivalAuditLog} = Actions;

export default connect(mapStateToProps, {
  getPortArrivalAuditLog,
})(PortArrivalAudit);
